import { format as dateFnsFormat, parseISO } from 'date-fns'
import da from 'date-fns/locale/da'
import sv from 'date-fns/locale/sv'
import de from 'date-fns/locale/de'
import fr from 'date-fns/locale/fr'
import fi from 'date-fns/locale/fi'
import ja from 'date-fns/locale/ja'
import { t } from 'i18next'

import { insertIf } from './general-helpers'
import { Locale } from '@/types'

export const locales = {
  da,
  sv,
  de,
  fr,
  fi,
  ja,
}

const format = (
  date: string | Date,
  formatStr?: string,
  customLocale?: Locale,
) => {
  if (!date) {
    return null
  }

  if (typeof date === 'string') {
    date = parseISO(date)
  }

  const locale = customLocale
    ? customLocale.substring(0, 2)
    : window.__localeId__

  if (formatStr === 'text') {
    formatStr = locale === 'da' ? 'd. MMMM yyyy' : 'MMMM d, yyyy'
  }

  try {
    return dateFnsFormat(date, formatStr ?? 'dd-MM-yyyy', {
      locale: locales[locale as keyof typeof locales],
    })
  } catch (e: any) {
    console.error('Invalid date: ', date, e.message)
    return null
  }
}

export const dateFormatOptions = (
  locale: Locale,
  includeLanguageDefault = false,
) => [
  ...insertIf(includeLanguageDefault, {
    key: 'default',
    value: 'default',
    text: t('Use language default'),
  }),
  {
    key: 'dd-MM-yyyy',
    value: 'dd-MM-yyyy',
    text: `20-07-${new Date().getFullYear()}`,
  },
  {
    key: 'yyyy-MM-dd',
    value: 'yyyy-MM-dd',
    text: `${new Date().getFullYear()}-07-20`,
  },
  {
    key: 'dd/MM/yyyy',
    value: 'dd/MM/yyyy',
    text: `20/07/${new Date().getFullYear()}`,
  },
  {
    key: 'yyyy/MM/dd',
    value: 'yyyy/MM/dd',
    text: `${new Date().getFullYear()}-07-20`,
  },
  {
    key: 'text',
    value: 'text',
    // dates formatted with month as text names are different in danish
    text: format(
      new Date(`${new Date().getFullYear()}-07-20`),
      locale === 'da_DK' ? 'd. MMMM yyyy' : 'MMMM d, yyyy',
    ),
  },
]

export default format
